<div class="container-fluid">
	<div class="row">
		<div class="col-lg-12">
			<h3 class="page-header">My User Profile</h3>
		</div>
	</div>
	<div class="row">
		<div class="row top10">
			<div class="col-xs-11">
				<h3>Upload Signature</h3>Only needed for req approvers/management
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-11">
				<img *ngIf="sig" [src]="s.bypassSecurityTrustUrl(sig)" />
			</div>
		</div>
		<div class="row ">
			<div class="col-xs-11">
          <aims-file-upload
                [ngModel]="sigName"
                name="Documentation"
                [maxFileSize]="4194304"
                [allowedFileType]="'.jpg,.png,.bmp'"
                [saveUrl]="'User/SaveSig?empId='+user?.employeeId"
							  [removeUrl]="'User/DeleteSig?empId='+user?.employeeId"
                (success)="sigChanged()"
                (fileDeleted)="sigChanged()"
              ></aims-file-upload>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-11">
				<h3>Set Defaults</h3>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Site:</b>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
        <mat-form-field appearance="fill">
          <mat-select
            name="Site"
            [(ngModel)]="defaultSiteId"
            (selectionChange)="saveDefaults()" >
            <mat-option *ngFor="let s of sitesValues | async" [value]="s.siteId">
                {{ s.siteName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Pay Site:</b>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
        <mat-form-field appearance="fill">
          <mat-select
            name="DefaultPaySite"
            [(ngModel)]="defaultPaySiteId"
            (selectionChange)="saveDefaults()" >
            <mat-option ></mat-option>
            <mat-option *ngFor="let s of sitesValues | async" [value]="s.siteId">
                {{ s.payrollSiteName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Facilities Grid:</b>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
        <mat-form-field appearance="fill">
          <mat-select
            name="DefaultFacilitiesGrid"
            [(ngModel)]="defaultFacilitiesGrid"
            (selectionChange)="saveDefaults()" >
            <mat-option></mat-option>
            <mat-option *ngFor="let t of [{text:'Basic',value:'basic'},{text:'Full',value:'full'}]" [value]="t.value">
                {{ t.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Inventory Grid:</b>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
        <mat-form-field appearance="fill">
          <mat-select
            name="DefaultInventoryGrid"
            [(ngModel)]="defaultInventoryGrid"
            (selectionChange)="saveDefaults()" >
            <mat-option></mat-option>
            <mat-option *ngFor="let t of [{text:'Basic',value:'basic'},{text:'Full',value:'full'}]" [value]="t.value">
                {{ t.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Scheduler View:</b>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12">
        <mat-form-field appearance="fill">
          <mat-select
            name="DefaultSchedulerView"
            [(ngModel)]="defaultSchedulerView"
            (selectionChange)="saveDefaults()" >
            <mat-option></mat-option>
            <mat-option *ngFor="let t of [{text:'Calendar',value:'calendar'},{text:'Gantt',value:'gantt'}]" [value]="t.value">
                {{ t.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
		<div class="row top10">
			<div class="col-xs-12">
				<b>Default Work Section:</b>				
			</div>
		</div>		
		<div class="row">		
			<div class="col-xs-12">
        <mat-form-field appearance="fill">	
		  <mat-label>{{ defaultWorkSectionId === null ? 'All': ""}}</mat-label>		  			  
          <mat-select
            name="DefaultWorkSection"
            [(ngModel)]= "defaultWorkSectionId"			
            (selectionChange)="saveDefaults()" >			
			<mat-option [value]="null">All</mat-option>
            <mat-option *ngFor="let ws of workSectionValues | async" [value]="ws.workSectionId">
                {{ ws.workSection }}
            </mat-option>
          </mat-select>
        </mat-form-field>
			</div>
		</div>
	</div>
	<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
